import { AttachmentWithUploadStatus } from 'types/AttachmentWithUploadStatus'

import { AttachmentIconAndStatus } from './AttachmentIconAndStatus'
import { AttachmentInfo } from './AttachmentInfo'

import type { FC } from 'react'

type Props = {
  attachment: AttachmentWithUploadStatus
}

export const AttachmentPopover: FC<Props> = ({ attachment: { capacityUsage, contentType, errorType, filename, status } }) => (
  <div className="flex items-center gap-x-2">
    <AttachmentIconAndStatus
      attachmentStatus={status}
      contentType={contentType}
      isDetailedView
    />
    <AttachmentInfo
      capacityUsage={capacityUsage}
      contentType={contentType}
      errorType={errorType}
      filename={filename}
      isDetailedView
      isPending={status === 'deleting' || status === 'uploading'}
    />
  </div>
)
